"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NoopStore = void 0;
class NoopStore {
  constructor() {
    this.value = null;
  }
  delete() {
    this.value = null;
  }
  get() {
    if (typeof this.expires !== 'undefined' && this.expires < new Date().getTime()) {
      return null;
    }
    return this.value;
  }
  set(value, expires) {
    this.value = value;
    this.expires = expires === null || expires === void 0 ? void 0 : expires.getTime();
  }
}
exports.NoopStore = NoopStore;